import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import ComponenteProduto from "model/administracao/cadastro/produto/ComponenteProduto";
import Produto from "model/administracao/cadastro/produto/Produto";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import ProdutoService from "service/administracao/cadastro/produto/ProdutoService";
import { produtoCompleteMethod, produtoItemTemplate } from "utils/autocompleteUtils";

type Props = {
    visible: boolean;
    onConfirm: (value: ComponenteProduto[]) => void;
    onCancel: () => void;
}
const produtoService = new ProdutoService();

export default function ModalDuplicarComponentes(props: Props) {

    const { msgAlerta } = useToastContext();
    const [produto, setProduto] = useState<Produto>(new Produto());
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState<Produto[]>([]);

    useEffect(() => {
        produtoService.getAllWithComponentes().then(data => {
            setProdutos(data);
        }).catch(err => {
            msgAlerta("Erro", "Erro ao buscar produtos");
        });
    }, [])

    const footer = <div>
        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-danger" onClick={props.onCancel} />
        <Button label="Confirmar" icon="pi pi-check" className="p-button-text" onClick={() => podeConfirmar() ? props.onConfirm(produto.componentes as ComponenteProduto[]) : null} />
    </div>

    function podeConfirmar(): boolean {
        if (!produto || !produto.codigo) {
            msgAlerta("Produto", "Selecione um produto")
            return false;
        }
        return true;
    }

    return (
        <Dialog visible={props.visible} header="Duplicar componentes" footer={footer} modal={true} onHide={props.onCancel}>
            <div style={{ width: "100%", display: "flex", flexDirection: "column", rowGap: 16 }}>
                <div>
                    <Label>Produto</Label>
                    <div style={{ display: "flex", width: "100%", gap: 8 }}>
                        <AutoComplete
                            value={produto}
                            placeholder="Selecione um Produto"
                            style={{ width: '100%' }}
                            inputStyle={{ width: '100%' }}
                            field="nome"
                            itemTemplate={(item: Produto) => produtoItemTemplate(item)}
                            suggestions={produtosFiltrados}
                            completeMethod={(e) => {
                                let filtered = produtoCompleteMethod(produtos, e.query);
                                setProdutosFiltrados(filtered);
                            }}
                            onChange={(e) => {
                                let produtoLocal = JSON.parse(JSON.stringify(produto));
                                if (typeof e.target.value == "string") {
                                    let prod = new Produto();
                                    prod.nome = e.target.value;
                                    produtoLocal = prod;
                                } else {
                                    produtoLocal = e.target.value;
                                }

                                setProduto(produtoLocal);
                            }}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    )
}